import type { ReactNode } from "react";
import styles from "./workspace-frame.module.css";

export function EditorWorkspace({ children, className = "", ariaLabel }: { children: ReactNode; className?: string; ariaLabel?: string }) {
  return <main className={`page ${styles.workspace} ${className}`.trim()} aria-label={ariaLabel} data-workspace="editor">{children}</main>;
}
